angular
  .module("app")
  .controller("DataCompletitionCtrl", function (
    $scope,
    $instantLeasingService,
    $modalService,
    InstantModel,
    $location,
    $transactionFactory,
    $searchUserService,
    RiUserG,
    Fatturazione,
    $rootScope,
    DocumentazioneAggiuntiva,
    $timeout
  ) {
    $scope.$modalService = $modalService;
    var self = this;
    self.cervedUpdate = false;
    $scope.enableButton = true;

    var init = function () {
      $scope.loading = false;
      $scope.finito = false;
      $scope.instantModel = $transactionFactory.get();
      $scope.formaGiuridica = "";
      $scope.proposta = "Proposta N°.: " + $scope.instantModel.idWfInstance;
    };

    init();
    /**
     * Navigation
     */
    $scope.navigator = {
      getPageIndex: function () {
        return $scope.instantModel.viewIndex;
      },
      nextPage: function () {
        /**
         * If view index is 0, call insert instance,
         */
        if ($scope.instantModel.viewIndex === 0) {
          //Gets idWfInstance from the current transaction
          var currentTransaction = $transactionFactory.get();

          $scope.instantModel.idWfInstance = currentTransaction.idWfInstance;
          $scope.instantModel.idAppVendor = currentTransaction.identifierVendor;

          $scope.proposta = "Proposta N°: " + $scope.instantModel.idWfInstance;

          var updatedModel = InstantModel.build($scope.instantModel);

          $instantLeasingService.nextStep(updatedModel)
            .then(function (newInstantModel) {

              $searchUserService.getAppUserFromCerved($transactionFactory.get().appIlTransaction.id)
                .then(function (appCustomerUser) {

                  if (appCustomerUser) {
                    //aggiorno il metadato con i dati del cliente, se già noto
                    var newCustomerMetadata = Object.assign(
                      newInstantModel.financialCustomer.metadata, {
                        riUserG: RiUserG.build(appCustomerUser.metadata.riUserG)
                      }
                    );
                    newInstantModel.financialCustomer.metadata = newCustomerMetadata;
                    $scope.instantModel = newInstantModel;
                  }

                })
                .catch(function (err) {
                  console.log("spaccato: ", err);
                })
                .finally(function () {
                  console.info("finito getAppUserFromCerved");
                });
            })
            .finally(function () {
              console.info("finito nextStep");
            });

        } else {
          /**
           * call nextStep instead
           */
          $instantLeasingService
            .nextStep($scope.instantModel)
            .then(function (newInstantModel) {
              $scope.instantModel = newInstantModel;
            });
        }
      },
      back: function () {
        var self = this;
        /**
         * call backStep
         */
        $instantLeasingService
          .backStep($scope.instantModel)
          .then(function (newInstantModel) {
            console.log("new model returned: ", newInstantModel);
            $scope.instantModel = newInstantModel;
          });
      },
      suspend: function () {
        var self = this;

        $instantLeasingService
          .suspendInstance($scope.instantModel)
          .then(function (success) {
            if (success) {
              $modalService.closeModal("suspendInstance");
              $location.path("/");
            }
          })
          .catch(function (err) {
            console.log("suspend instance failed! Error cause was: " + err);
          });
      },
      finish: function () {
        var self = this;

        $instantLeasingService
          .submitRequest($scope.instantModel)
          .then(function (response) {
            console.log("response: ", response);
            if (response) {
              $location.path("/");
            }

          })
          .catch(function (err) {

            console.error("err: ", err);

            $rootScope.$broadcast("addAlert", {
              text: ERROR_TEC
            });
          })
          .finally(function () {});
      }
    };

    /** end Navigation **/


  });